import { Controller } from "@hotwired/stimulus"
import { setHidden } from "./sheet_steps_controller"

// Who the visit is about, one choice at a time: the pill radios pick a
// subject and the panels for it show. A panel lists the subjects it serves in
// `data-subject` (space-separated). Hidden panels have their controls disabled
// so an abandoned subject's fields never post. Only fields this controller
// disabled are re-enabled: a retired answer option or an escaped question is
// disabled on its own account and must stay so.
export default class extends Controller {
  static targets = ["panel"]

  declare readonly panelTargets: HTMLElement[]

  connect() {
    const checked = this.element.querySelector<HTMLInputElement>('input[name="subject"]:checked')
    const fixed = this.element.querySelector<HTMLInputElement>('input[type="hidden"][name="subject"]')
    this.apply((checked || fixed)?.value)
  }

  switch(event: Event) {
    this.apply((event.target as HTMLInputElement).value)
  }

  private apply(subject: string | undefined) {
    if (!subject) return
    this.panelTargets.forEach((panel) => {
      const on = (panel.dataset.subject || "").split(" ").includes(subject)
      setHidden(panel, !on)
      panel.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>("input, select, textarea")
        .forEach((field) => {
          if (on) {
            if (field.dataset.subjectDisabled) { field.disabled = false; delete field.dataset.subjectDisabled }
          } else if (!field.disabled) {
            field.disabled = true
            field.dataset.subjectDisabled = "true"
          }
        })
    })
  }
}
